import React from 'react'
import {Loader} from './AppPages/_Common'
export const LoadingApp = (props)=>{
    return(
        <Loader/>
    )
}